import React, { useEffect, useRef, useState } from 'react'
import './style.css'
import ListView from '../listview/ListView'
import Arrow from '../../../assets/images/ui/arrow-down.png'

export default function DropDownList({content, text, id}) {

    const [active, setActive] = useState(false);
    const list = useRef(null), arrowIcon = useRef(null);

    useEffect(() => {

        if(list != null){
            if(active){
                list.current.style.transform = "translateY(0px) scaleY(1)";
                list.current.style.height = "auto";
                arrowIcon.current.style.transform = "rotate(180deg)"
            }else{
                list.current.style.transform = "translateY(-"+(list.current.offsetHeight / 2)+"px) scaleY(0)";
                arrowIcon.current.style.transform = "rotate(0deg)"
                setTimeout(() => {
                    list.current.style.height = "0px";
                },300)
            }
        }   
        
    },[active])

  return (
    <div className='DropDownList' id={id}>
        <div className='title-div'>
            <p className='main-text'>{text}</p>
            <img src={Arrow} alt='' onClick={() => setActive(!active)} ref={arrowIcon} />
        </div>

        <ListView reference={list}>
            {content}
        </ListView>
    </div>
  )
}
